import './ModalBody.scss';
import clsx from 'clsx';
import React, { memo, ReactNode } from 'react';

type Props = {
  danger?: boolean;
  shaded?: boolean;
  children: ReactNode;
};

export const ModalBody = memo(({ danger, shaded, children }: Props) => (
  <div className={clsx({
    'bp-modal-body': true,
    'bp-modal-body--danger': danger,
    'bp-modal-body--shaded': shaded,
  })}
  >
    {children}
  </div>
));
